/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Tags_ErrorInputs */

const en_dialog_tags_error = /** @type {(inputs: Dialog_Tags_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error while updating the audio item`)
};

const es_dialog_tags_error = /** @type {(inputs: Dialog_Tags_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un error al actualizar el elemento de audio`)
};

/**
* | output |
* | --- |
* | "There was an error while updating the audio item" |
*
* @param {Dialog_Tags_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_tags_error = /** @type {((inputs?: Dialog_Tags_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Tags_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_tags_error(inputs)
	return en_dialog_tags_error(inputs)
});